module.exports = __webpack_public_path__ + "fonts/a0041c8f-87d5-4762-9433-d1bd14041dd1.221dea46.eot";